<template>
  <div class="col-xl-8 col-md-12">
    <!-- Post -->
    <div class="row mt-2 mb-5 pb-3 mx-2">
      <!-- Card -->
      <div class="card card-body mb-5">
        <h2 class="font-weight-bold mt-3">
          <strong>Technical Program Committee</strong>
        </h2>
        <hr class="red title-hr" />
        <p class="article">
          <span>Dr. Manisha Dubey, MANIT, Bhopal</span> <br />
          <span>Dr. A. Kumar, NIT Kurukshetra</span> <br />
          <span>Dr. Abhijeet Gorey, TCS Research</span> <br />
          <span>Dr. Della Thomas, IIIT Kottayam</span> <br />
          <span>Dr. Vani Damodaran, Forus Health</span> <br />
          <span>Dr. Nidul Sinha, NIT Silchar</span> <br />
          <span>Dr. Chandrashekhar N. Bhende, IIT Bhubaneswar</span> <br />
          <span>Dr. Rohit Bhakar, MNIT, Jaipur</span> <br />
          <span>Dr. Susovan Samant, NIT Rourkela</span> <br />
          <span>Dr. O. H. Gupta, NIT Jamshedpur</span> <br />
          <span>Dr. Saumendra Sarangi, MNNIT Allahabad</span> <br />
          <span>Dr. Papia Ray, VSSUT Burla</span> <br />
          <span>Dr. V. S. Kale, VNIT Nagpur</span> <br />
          <span>Dr. Ritesh Keshri, VNIT Nagpur</span> <br />
          <span>Dr. A. Kirubakaran, NIT Warangal</span> <br />
          <span>Dr. Kunisetti. V. Praveen Kumar, NIT Surat</span> <br />
          <span>Dr. Suresh Lakhimsetty, NIT Surat</span> <br />
          <span>Dr. Sateesh Kumar Kuncham, NIT Trichy</span> <br />
          <span>Dr. Ch. Ramulu, NIT Warangal</span> <br />
          <span>Dr. Shashank Kurm, IIT Bhilai</span> <br />
          <span>Dr. Shailendra Kumar, IIT Bhilai</span> <br />
          <span>Dr. Amit Ojha, MANIT, Bhopal</span> <br />
          <span>Dr. Hemachander Allamsetty, NIT Puducherry</span> <br />
          <span>Dr. Ranjan Kumar Behera, IIT Patna</span> <br />
          <span>Dr. Paresh Kumar Nayak, IIT (ISM) Dhanbad</span> <br />
          <span>Dr. Dipanshu Naware, NIT Trichy</span> <br />
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Technical_Committee",
};
</script>
